
import { Component, OnInit } from '@angular/core';
import { CarouselModule } from 'primeng/carousel';
import { RouterLink } from '@angular/router';
import { StaticWhyLoveComponent } from '../static-why-love/static-why-love.component';
@Component({
  selector: 'app-why-love-paper',
  imports: [
    CarouselModule,
    StaticWhyLoveComponent
  ],
  templateUrl: './why-love-paper.component.html',
  styleUrl: './why-love-paper.component.css'
})
export class WhyLovePaperComponent implements OnInit {



  responsiveOptions: any[] | undefined;

  subjects: any[] =
    [
      {
        name: 'Get Real Exam Experience',
        icon: 'Icons/paper1.png',
        discrption: "Practice with actual past papers to familiarize yourself with exam formats, question types, and time management skills."
      },
      {
        name: 'Identify Weak Areas',
        icon: 'Icons/paper2.png',
        discrption: "Spot the difficult questions and focus your revision on topics that need improvement"
      },

      {
        name: 'Build Exam Confidence',
        icon: 'Icons/paper3.png',
        discrption: "Regular practice helps you approach exams prepared and confident."
      },




    ]


  ngOnInit(): void {
    this.responsiveOptions = [
      {
        breakpoint: '1400px',
        numVisible: 2,
        numScroll: 1
      },
      {
        breakpoint: '1199px',
        numVisible: 3,
        numScroll: 1
      },
      {
        breakpoint: '767px',
        numVisible: 2,
        numScroll: 1
      },
      {
        breakpoint: '575px',
        numVisible: 1,
        numScroll: 1
      }
    ]
  }

}
